import {useNavigate} from 'react-router-dom';
import {
  SoopButtonCommon,
  SoopChipLegacy,
  SoopSectionTitle,
} from '@soop-ui/soop-ui';
import {useHelpContext} from '@/app/(main)/routes/help/context/HelpContext';
import {ROUTE} from '@/constants/main/route';
import {HELP_LOG} from '@/constants/help';
import {useAutoCloseDialog, useGetFaqTopList} from '@/hooks/help';
import useBackgroundLocation from '@/hooks/useBackgroundLocation';
import {sendHelpClickLog} from '@/utils/help/log';
import SectionLoading from '@/components/help/common/SectionLoading';
import QuestionLayer from './QuestionLayer';
import styles from './Question.module.scss';

const Question = () => {
  const {isMobile} = useHelpContext();
  const {openDialog} = useAutoCloseDialog();
  const {data: faqTopList = [], isLoading} = useGetFaqTopList();
  const navigate = useNavigate();
  const {navigateWithBackgroundLocation} = useBackgroundLocation();

  const handleOpenQuestionLayer = (questionId: string, title: string) => {
    if (isMobile) {
      navigateWithBackgroundLocation(ROUTE.HELP.LAYER_FAQ, {
        state: {questionId, title},
        preventScrollReset: true,
      });
    } else {
      openDialog({
        component: () => (
          <QuestionLayer
            isMobile={false}
            questionId={questionId}
            title={title}
          />
        ),
        scrollLock: true,
      });
    }
  };

  const handleAllViewClick = () => {
    navigate(ROUTE.HELP.FAQ);
    sendHelpClickLog(HELP_LOG.CODE_TYPE.MAIN_CONTENTS, {
      buttonType: HELP_LOG.BUTTON_TYPE.FAQ,
      actionType: HELP_LOG.ACTION_TYPE.TO_ALL,
    });
  };

  const handleQuestionClick = (questionId: string, title: string) => {
    handleOpenQuestionLayer(questionId, title);
    sendHelpClickLog(HELP_LOG.CODE_TYPE.MAIN_CONTENTS, {
      buttonType: HELP_LOG.BUTTON_TYPE.FAQ,
      actionType: HELP_LOG.ACTION_TYPE.TO_POPUP_ALL,
      text: title,
    });
  };

  return (
    <div className={styles.QuestionWrapper}>
      <SoopSectionTitle>
        <SoopSectionTitle.Title size='lg'>
          자주 묻는 질문
        </SoopSectionTitle.Title>
        <SoopSectionTitle.RightGroup>
          <SoopButtonCommon
            onClick={handleAllViewClick}
            endIconName='icoChevronLeft'
            size={32}
            variant='clearSecondary'>
            전체보기
          </SoopButtonCommon>
        </SoopSectionTitle.RightGroup>
      </SoopSectionTitle>
      {isLoading ? (
        <SectionLoading isMobile={isMobile} pcHeight={356} />
      ) : (
        <ul className={styles.QuestionList}>
          {faqTopList.map(({category, questionId, title}) => (
            <li key={questionId}>
              <button
                type='button'
                onClick={() => handleQuestionClick(questionId, title)}>
                <div className={styles.ListTitle}>
                  <span>Q.</span>
                  <p>{title}</p>
                </div>
                <SoopChipLegacy className={styles.QuestionChip}>
                  {category}
                </SoopChipLegacy>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Question;
